import Paragraph from './paragraph';
export default Paragraph;


// WEBPACK FOOTER //
// ./src/components/paragraph/index.js